"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var types_1 = require("../../types");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ActiveCoolingOffCard_1 = __importDefault(require("./ActiveCoolingOffCard"));
var EmptyCard_1 = __importDefault(require("../LimitCard/EmptyCard"));
var CoolingOffLimit = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, swr_hooks_1.useCoolingOffLimit)(), data = _a.data, isLoading = _a.isLoading, isValidating = _a.isValidating;
    if (isLoading || isValidating)
        return null;
    if (data)
        return react_1.default.createElement(ActiveCoolingOffCard_1.default, { data: data });
    return (react_1.default.createElement(EmptyCard_1.default, { title: t('coolingOff'), description: t('coolingOffDescription'), type: types_1.LimitType.COOLING_OFF }));
};
exports.default = CoolingOffLimit;
